"use client";

import { Clock, Globe, ShieldCheck, Users } from "lucide-react";
import { Container } from "@/components/ui/container";

const TRUST = [
  { label: "Government Communications", accent: "var(--color-cyan)" },
  { label: "Fortune 500", accent: "var(--color-crimson)" },
  { label: "Defense Agencies", accent: "var(--color-emerald)" },
  { label: "Public Figures", accent: "var(--color-purple)" },
  { label: "Financial Institutions", accent: "var(--color-amber)" },
  { label: "Political Organizations", accent: "var(--color-coral)" },
  { label: "Healthcare Networks", accent: "var(--color-cyan)" },
  { label: "Sovereign Entities", accent: "var(--color-denim)" },
];

const STATS = [
  { icon: Clock, value: "15+", label: "Years", color: "var(--color-crimson)" },
  { icon: Users, value: "300+", label: "Clients", color: "var(--color-purple)" },
  { icon: Globe, value: "Multi", label: "Continents", color: "var(--color-cyan)" },
  { icon: ShieldCheck, value: "Zero", label: "Incidents", color: "var(--color-emerald)" },
];

export function TrustStrip() {
  // Duplicate for seamless marquee
  const loop = [...TRUST, ...TRUST];
  return (
    <section className="relative py-12 border-y border-[rgb(var(--border)/0.12)] overflow-hidden">
      {/* Left/right fade masks */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[rgb(var(--bg))] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[rgb(var(--bg))] to-transparent z-10" />

      {/* Marquee */}
      <div className="flex animate-[marquee_30s_linear_infinite] gap-12 whitespace-nowrap">
        {loop.map((t, i) => (
          <div
            key={`${t.label}-${i}`}
            className="flex items-center gap-3 eyebrow-tiny text-[rgb(var(--fg-muted))]"
          >
            <span className="grid place-items-center h-8 w-8 rounded-full glass">
              <span className="h-1.5 w-1.5 rounded-full" style={{ background: t.accent }} />
            </span>
            {t.label}
          </div>
        ))}
      </div>

      {/* Stat strip */}
      <Container>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
          {STATS.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.label} className="flex items-center gap-2.5">
                <Icon className="h-4 w-4" style={{ color: s.color }} />
                <span className="display-stat-sm" style={{ color: s.color }}>
                  {s.value}
                </span>
                <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[rgb(var(--fg-subtle))]">
                  {s.label}
                </span>
              </div>
            );
          })}
        </div>
      </Container>

      <style jsx>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
